import React from 'react';
import './index.sp.scss';

import SpBasicTemplate from 'components/templates/SpBasicTemplate';
import SpStepProgressBar from 'components/molecules/SpStepProgressBar';
import SpPointComment from 'components/molecules/SpPointComment';
import SpInputTitle from 'components/molecules/SpInputTitle';
import DropdownInput from 'components/atoms/Input/DropdownInput';
import RequiredOrOptionalIcon from 'components/atoms/Icon/RequiredOrOptionalIcon';
import SpInputItem from 'components/molecules/SpInputItem';
import SpFreeInputArea from 'components/molecules/SpFreeInputArea';
import PcErrorArea from 'components/molecules/PcErrorArea';

import { POINT_COMMENT_MAP } from 'utils/constant';

// タイトル
const DispTitle = ({ title }) => {
  return Array.isArray(title) ? (
    title.map((line) => (
      <span key={line} className="">
        {line}
        <br />
      </span>
    ))
  ) : (
    <>{title}</>
  );
};

const PresentSP = ({
  onClickMainButton,
  welfareDisp,
  workEnviDisp,
  ageRangeDisp,
  genderRangeDisp,
  workEnviCmntDisp,
  valid,
  errorDispMap,
}) => (
  <div className="">
    <div className="AddEnvi SP">
      <SpBasicTemplate
        path={window.location.pathname}
        onClickMainButton={onClickMainButton}
        valid={valid}
      >
        {/* プログレスバー  */}
        <SpStepProgressBar currentStep="6" />

        {/* 画面名 */}
        <div className="titleArea">
          <div className="title">職場環境</div>
        </div>

        {/* リック&スーの吹き出し 上 */}
        <SpPointComment labelList={POINT_COMMENT_MAP.enviPointCmnt1.labelList} pattern={POINT_COMMENT_MAP.enviPointCmnt1.pattern} />

        {/* 利用可能な福利厚生施設 チェックボックス */}
        <SpInputTitle
          title={welfareDisp.title}
          label={welfareDisp.label}
          list={welfareDisp.list}
          type={welfareDisp.type}
          /* 福利厚生施設 テキストエリア */
          comment={
            !welfareDisp.comment ? (
              <></>
            ) : (
              <>
                <SpFreeInputArea
                  visible={welfareDisp.comment.visible}
                  title={welfareDisp.comment.title}
                  label={welfareDisp.comment.label}
                  questionMark={welfareDisp.comment.questionMark}
                  popUpTitle={welfareDisp.comment.popUpTitle}
                  popUpDetail={welfareDisp.comment.popUpDetail}
                  relativePosArrow={welfareDisp.comment.relativePosArrow}
                  name={welfareDisp.comment.name}
                  textAreaValue={welfareDisp.comment.textAreaValue}
                  cmntOnChange={welfareDisp.comment.cmntOnChange}
                  onInput={welfareDisp.comment.onInput}
                  onCompositionEnd={welfareDisp.comment.onCompositionEnd}
                  maxLength={welfareDisp.comment.maxLength}
                  placeholder={welfareDisp.comment.placeholder}
                  rows={welfareDisp.comment.rows}
                  cols={welfareDisp.comment.cols}
                  wordCount={welfareDisp.comment.wordCount}
                  errMessage={welfareDisp.comment.errMessage}
                  inValid={welfareDisp.comment.inValid}
                />
              </>
            )
          }
        />

        {/* リック&スーの吹き出し 下 */}
        <SpPointComment labelList={POINT_COMMENT_MAP.enviPointCmnt2.labelList} pattern={POINT_COMMENT_MAP.enviPointCmnt2.pattern} />

        {/* 職場の特徴（複数選択可） */}
        <div className="mT30px">
          <SpInputTitle
            title={workEnviDisp.title}
            label={workEnviDisp.label}
            list={workEnviDisp.list}
            type={workEnviDisp.type}
          />
        </div>

        {/* 職場の年齢層 */}
        <div className="SpInputTitle mT30px mB0">
          <div className="SITM-title">
            <DispTitle title="職場の年齢層" />
            <RequiredOrOptionalIcon label={ageRangeDisp.label} />
          </div>
        </div>

        <div className="AddEnvi_ageGroup">
          <span className="AddEnvi_ageGroup_DB">
            <DropdownInput
              items={ageRangeDisp.min.ageRangeList}
              selectedValue={ageRangeDisp.min.value}
              onChange={ageRangeDisp.min.onChange}
              isOpen={false}
              inValid={ageRangeDisp.min.inValid}
            />
          </span>
          <label>代</label>
          <label>～</label>
          <span className="AddEnvi_ageGroup_DB">
            <DropdownInput
              items={ageRangeDisp.max.ageRangeList}
              selectedValue={ageRangeDisp.max.value}
              onChange={ageRangeDisp.max.onChange}
              isOpen={false}
              inValid={ageRangeDisp.max.inValid}
            />
          </span>
          <label>代</label>
        </div>
        <div className=''>
          <PcErrorArea position='' message={errorDispMap.ageRange} />
        </div>

        {/* 男女比率 */}
        <div className="SpInputTitle mT30px">
          <SpInputItem
            title={genderRangeDisp.title}
            label={genderRangeDisp.label}
            questionMark={false}
          >
            {genderRangeDisp.list}
          </SpInputItem>
        </div>

        {/* 上記以外の特徴 テキストエリア */}
        <div className="workEnviCmnt">
          <SpInputTitle
            title={workEnviCmntDisp.title}
            label={workEnviCmntDisp.label}
            list={workEnviCmntDisp.list}
            type={workEnviCmntDisp.type}
            errorDispMessages={workEnviCmntDisp.errorDispMessages}
          />
        </div>
      </SpBasicTemplate>
    </div>
  </div>
);

export default PresentSP;
